import { Card, CardContent } from "@/components/ui/card";
import { Mail } from "lucide-react";

export const MaintenanceNote = () => {
  return (
    <Card className="relative overflow-hidden mb-8 bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5 border-2 border-primary/20 shadow-lg animate-pulse">
      {/* Glowing border effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary via-secondary to-accent opacity-20 blur-sm animate-pulse" />
      <div className="absolute inset-[2px] bg-background rounded-lg" />
      
      {/* Content */}
      <CardContent className="relative p-6 space-y-4">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
          <h3 className="text-lg font-bold text-primary">NOTE</h3>
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
        </div>
        
        <div className="space-y-4 text-sm leading-relaxed">
          <p className="font-medium">
            This section is currently under maintenance. As a solo founder working with limited resources, 
            I'm facing some challenges in managing community chatrooms.
          </p>
          
          <p>
            If you're passionate about AI, prompts, or building impactful platforms, I'd love to collaborate 
            with like-minded people to make this space stronger together.
          </p>
          
          <div className="flex items-center gap-2 pt-2">
            <span className="font-semibold">👉 Interested? Reach out — let's build something amazing.</span>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-2 pt-2">
            <div className="flex items-center gap-2 px-3 py-2 bg-primary/10 rounded-lg border border-primary/20">
              <Mail className="h-4 w-4 text-primary" />
              <span className="text-sm font-mono">contact@thepromptspace.com</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-2 bg-secondary/10 rounded-lg border border-secondary/20">
              <Mail className="h-4 w-4 text-secondary" />
              <span className="text-sm font-mono">thepromptspace@gmail.com</span>
            </div>
          </div>
        </div>
      </CardContent>
      
      {/* Additional glow effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-primary/30 via-secondary/30 to-accent/30 rounded-lg blur-md -z-10 animate-pulse" />
    </Card>
  );
};